import * as yup from "yup";

const newPasswordSchema = yup.object({
  password: yup.string().required().trim()
    .matches(/^(?=.*[#/¡!-.¿?])(?=.*[0-9]).{8,}$/ , 'Is not in correct format'),
  confirm: yup.string().oneOf([yup.ref('password'), null]).required().trim()
}).required();

export default newPasswordSchema;
